import { render } from "./5StarsForex.vue?vue&type=template&id=1d3ebadc"
import script from "./5StarsForex.vue?vue&type=script&lang=js"
export * from "./5StarsForex.vue?vue&type=script&lang=js"

import exportComponent from "E:\\AStrick-Web\\vue-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__